// extracted by mini-css-extract-plugin
export default {"SearchInput":"styles_SearchInput__81Jmb"};